import $ from 'jquery'

const headerOffset = window.location.href.indexOf('openseason') > 0 ? -95 : 42

export function init() {
  $('a[href*="#"]').each((i, link) => {
    const $link = $(link)
    const anchorParts = $link.attr('href').split('#')
    const anchor = anchorParts[anchorParts.length - 1]
    if (!anchor) return
    let $target = $(`a[name="${anchor}"]`)

    if (!$target.length && anchor !== '/') {
      $target = $(`#${anchor}`)
    } else {
      $target = $(`#`)
    }

    if ($target.length) {
      $link.on('click', (event) => {
        event.preventDefault()
        scrollTo($target)
      })
    }
  })
}

export function scrollTo(element) {
  const $elem = $(element)
  let $scrollToElem = $elem
  let scrollOffset = -headerOffset

  // get correct element to scroll to
  if ($elem.next().length && $elem.next()[0].tagName == 'SECTION') {
    $scrollToElem = $elem.next()
  } else if ($elem.parents('section').length) {
    $scrollToElem = $elem.parents('section').first()
  } else if ($elem.find('.form-message.error:not(:empty)').length) {
    $scrollToElem = $elem.find('.form-message.error:not(:empty)').first()
    scrollOffset = 120
  }

  let position = $scrollToElem.position().top - scrollOffset

  const scroll = $(window).scrollTop()
  const time = Math.min(Math.abs(scroll - position) / 2, 1500) // distance / 3, or 1.5 seconds max
  $('html, body').animate({ scrollTop: position }, time, 'swing')
}
